// Port of ecommerce/lib.coffee — chartViewOptions, viewModeCategory helpers, defaultChartView.
// Do NOT import from coffee — we want the React component fully decoupled from StatPage namespace.
// The option list is shared with the controls; re-exported so chart lib code reads one source
// and cannot drift out of sync with what the view-mode dropdown actually offers.

import {
  BANNER_VIEW_OPTION_KEYS,
  CHART_VIEW_OPTIONS,
  SUBSCRIBE_VIEW_OPTION_KEYS
} from '@aytm/app/stats/page/question-views/sh/lib/constants'

export { CHART_VIEW_OPTIONS }

export const DEFAULT_CHART_VIEW = 'amount'

// Subset of the subscribe category that renders as a rate (%) — excludes subscribeSpend
// (money) and frequency (stacked, handled by lib/frequency.js).
export const SUBSCRIBE_RATE_MODES = ['subscribeRate', 'considerationRate', 'churnRate', 'reversalRate']

// Banner and subscribe metrics live in their own payload branches (answer.banners /
// answer.subscribe) rather than under answer.aN, so getAnswer dispatches on this.
export const viewModeCategoryOf = viewMode => {
  if (BANNER_VIEW_OPTION_KEYS.includes(viewMode)) return 'banner'
  if (SUBSCRIBE_VIEW_OPTION_KEYS.includes(viewMode)) return 'subscribe'
  return null
}

// Those same branches carry no per-trait breakdown, so trait splitting is suppressed.
export const isTraitExcluded = viewMode => ['banner', 'subscribe'].includes(viewModeCategoryOf(viewMode))
